import { render, staticRenderFns } from "./SentIcon.vue?vue&type=template&id=435fcc09&scoped=true&"
import script from "./SentIcon.vue?vue&type=script&lang=ts&"
export * from "./SentIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435fcc09",
  null
  
)

export default component.exports